import { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';

// Animates a numeric-looking string (e.g. "100+", "5.0", "3+") counting up
// from 0 once it scrolls into view. Non-numeric values (e.g. "DMV") render as-is.
export const AnimatedCounter = ({ value, duration = 1.4, className = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });
  const [display, setDisplay] = useState(() => {
    const match = String(value).match(/^([^\d]*)([\d.]+)(.*)$/);
    return match ? `${match[1]}0${match[3]}` : value;
  });

  useEffect(() => {
    if (!isInView) return;
    const match = String(value).match(/^([^\d]*)([\d.]+)(.*)$/);
    if (!match) {
      setDisplay(value);
      return;
    }
    const [, prefix, numStr, suffix] = match;
    const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
    const target = parseFloat(numStr);
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const progress = Math.min((now - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(`${prefix}${(target * eased).toFixed(decimals)}${suffix}`);
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [isInView, value, duration]);

  return <span ref={ref} className={className}>{display}</span>;
};
